import React, { type ReactNode } from "react"
import styles from "./visualiser-group.module.css"
import { mapVisualiserGroupChildren } from "../VisualiserGroup.vm"

type VisualiserGroupProps = {
  children?: ReactNode
  className?: string
}

export const VisualiserGroup = ({ children, className }: VisualiserGroupProps) => {
  const groupedChildren = mapVisualiserGroupChildren({ children })
  const rootClassName = [
    styles["visualiser-group"],
    "uv-inserts-visualiser-group",
    className,
  ]
    .filter(Boolean)
    .join(" ")

  return <div className={rootClassName}>{groupedChildren}</div>
}
